module.exports = __webpack_public_path__ + "static/media/nvshen-hufu.d2a0baf3.png";